import { render, staticRenderFns } from "./StyledButtonLight.vue?vue&type=template&id=5f2cc4d4"
import script from "./StyledButtonLight.vue?vue&type=script&lang=js"
export * from "./StyledButtonLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports